import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Field, inp, btn, sentForApproval } from "../../lib/ops";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

const today = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });

export const TemplateDialog = ({ uid, order, onClose, onDone }) => {
  const [rows, setRows] = useState(null);
  const [tid, setTid] = useState("");
  const [start, setStart] = useState((order.po_date || today()).slice(0, 10));
  useEffect(() => {
    api.get("/ops/templates").then((r) => {
      const act = r.data.items.filter((t) => t.active);
      setRows(act);
      setTid((act.find((t) => t.product_category === order.product_category) || act[0] || {}).template_id || "");
    }).catch((e) => toast.error(errMsg(e)));
  }, [order.product_category]);
  const apply = () => api.post(`/ops/plans/${uid}/apply-template`, { template_id: tid, start }).then((r) => {
    if (sentForApproval(r)) { onDone(); return; }
    toast.success(`${r.data.steps} steps added, ${r.data.start} to ${r.data.end}`);
    if (r.data.warning) toast.warning(r.data.warning, { duration: 12000 });
    onDone();
  }).catch((e) => toast.error(errMsg(e)));
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md bg-card" data-testid="tpl-apply-dialog">
        <DialogHeader><DialogTitle>Add steps from a template</DialogTitle></DialogHeader>
        <p className="text-xs text-muted-foreground">Steps are dated forward on working days from the start date and their deadlines are fixed.</p>
        <div className="space-y-3">
          <Field label="Template"><select data-testid="tpl-apply-select" value={tid} onChange={(e) => setTid(e.target.value)} className={inp}>
            {(rows || []).map((t) => <option key={t.template_id} value={t.template_id}>{t.name} · {t.steps.length} steps{t.product_category === order.product_category ? " (this product type)" : ""}</option>)}</select></Field>
          <Field label="Start (PO date)"><input type="date" data-testid="tpl-apply-start" value={start} onChange={(e) => setStart(e.target.value)} className={inp} /></Field>
          <button data-testid="tpl-apply-submit" disabled={!tid || !start} onClick={apply} className={btn}>Add steps</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const DatesDialog = ({ step, meta, onClose, onDone }) => {
  const [f, setF] = useState({ new_start: step.baseline_start || "", new_end: step.baseline_end || "", reason: "" });
  const n = step.date_changes || 0;
  const save = () => api.post(`/ops/processes/${step.process_id}/dates`, { version: step.version, ...f }).then((r) => { if (!sentForApproval(r)) toast.success("Dates changed"); onDone(); onClose(); })
    .catch((e) => toast.error(errMsg(e)));
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md bg-card" data-testid="dates-dialog">
        <DialogHeader><DialogTitle>Change dates: {step.name}</DialogTitle></DialogHeader>
        <p className="text-xs text-muted-foreground" data-testid="dates-count">{meta.date_rule === "limited" ? `Change ${n + 1} of ${meta.date_limit}. After ${meta.date_limit} changes only a founder or the managing partner can change this step.` : `Change ${n + 1}.`} The original date stays in the history and in the on-time score.</p>
        <div className="grid grid-cols-2 gap-2">
          <Field label="New start"><input type="date" data-testid="dates-new-start" value={f.new_start} onChange={(e) => setF({ ...f, new_start: e.target.value })} className={inp} /></Field>
          <Field label="New end"><input type="date" data-testid="dates-new-end" value={f.new_end} onChange={(e) => setF({ ...f, new_end: e.target.value })} className={inp} /></Field>
        </div>
        <Field label="Why"><textarea data-testid="dates-reason" value={f.reason} onChange={(e) => setF({ ...f, reason: e.target.value })} className="w-full bg-muted/60 border p-2 text-sm h-20" /></Field>
        <button data-testid="dates-submit" disabled={f.reason.trim().length < 3 || !f.new_start || !f.new_end} onClick={save} className={btn}>Save new dates</button>
      </DialogContent>
    </Dialog>
  );
};
